import React from "react";
import ReactDOM from "react-dom";

import App from "pages/_app";

ReactDOM.render(<App />, document.getElementById("root"));
